import { useGameReferrerDeepLink } from "@/hooks/useGameReferrerDeepLink"

export default function GameReferrerCapture() {
  useGameReferrerDeepLink()
  return null
}
